import React from "react";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import { FaUniversity } from "react-icons/fa";
import Modal from "./Modal";
import * as actions from "../redux/actions/checkoutActions";
import "./styles/ModalTransferDetails.css";

class ModalTransferDetails extends React.Component {
  state = {
    ready: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen && this.props.adId) {
      this.loadBanks();
    }
    if (!this.props.isOpen && prevProps.isOpen) {
      this.setState({ ready: false });
    }
  }

  loadBanks = async () => {
    const { user_id, token, adId } = this.props;
    if (!user_id || !token || !adId) return;

    await this.props.LoadCheckout(user_id, token, adId);
    this.setState({ ready: true });
  };

  renderBanks() {
    const accounts = this.props.bankAccounts || [];

    if (accounts.length === 0) {
      return (
        <p className="transfer-modal__empty">
          <Translate value="checkout_no_banks" />
        </p>
      );
    }

    return (
      <ul className="transfer-modal__list">
        {accounts.map((acc) => (
          <li key={acc.Id} className="transfer-modal__bank">
            <div className="transfer-modal__bank-icon">
              <FaUniversity />
            </div>
            <div className="transfer-modal__bank-body">
              <span className="transfer-modal__bank-name">{acc.Bank}</span>
              <span className="transfer-modal__bank-holder">{acc.HolderName}</span>
              <span className="transfer-modal__bank-number">
                {acc.AccountNumber}
                {acc.AccountType
                  ? " · " + I18n.t("bank_account_type_" + acc.AccountType)
                  : ""}
              </span>
              {acc.Identification ? (
                <span className="transfer-modal__bank-id">{acc.Identification}</span>
              ) : null}
            </div>
            {acc.QrUrl ? (
              <a
                href={acc.QrUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="transfer-modal__bank-qr"
              >
                <img src={acc.QrUrl} alt="QR" />
              </a>
            ) : null}
          </li>
        ))}
      </ul>
    );
  }

  render() {
    const { isOpen, onClose } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={<Translate value="checkout_banks_title" />}
      >
        <div className="transfer-modal">
          {!this.state.ready || this.props.loading ? (
            <p className="transfer-modal__loading">
              <Translate value="loading" />
            </p>
          ) : (
            this.renderBanks()
          )}
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    bankAccounts: reducer.checkout.bankAccounts,
    loading: reducer.checkout.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadCheckout: (user_id, token, goder_id) =>
    dispatch(actions.loadSellerCheckout({ user_id, token, goder_id })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalTransferDetails);
